<template>
  <el-dialog :visible.sync="dialogVisible" width="880px" @close="onBatchModifyCancel">
    <div slot="title">
      <div class="modal-title">
        <h4>{{ title }}</h4>
        <span v-if="rows && rows.length">已选{{ rows.length }}个账号</span>
      </div>
    </div>
    <div class="ghost-button-styles">
      <el-form ref="form" label-width="90px" :model="{}">
        <el-form-item label="生效方式">
          <el-radio-group v-model="form.batchTaskType" @change="onBatchTaskTypeChange">
            <el-radio-button ghost :label="1">立即生效</el-radio-button>
            <el-radio-button ghost :label="2">次日0点生效</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="统一设置">
          <el-radio-group v-model="form.isLimited">
            <el-radio-button ghost :label="1">设置预算</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <div class="budget-value">
            <el-select v-model="form.budgetType" placeholder="请选择" @change="onBudgetValueTypeChange">
              <el-option
                v-for="item in [
                  { label: '指定预算', value: 1 },
                  { label: '增加预算', value: 2 },
                  { label: '减少预算', value: 3 }
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <el-input
              class="budget-input"
              v-model="form.budgetValue"
              @keyup.enter.native="onBudgetValueConfirm"
              @blur="onBudgetValueConfirm"
              placeholder="预算值不能低于300，增减幅度不小于100"
            >
              <template slot="append">
                <el-select v-model="form.unitType" @change="onBudgetValueConfirm">
                  <el-option label="元" :value="1"></el-option>
                  <el-option v-if="[2, 3].includes(form.budgetType)" label="%" :value="2"></el-option>
                </el-select>
              </template>
            </el-input>

            <el-button type="text" @click="onBudgetValueUseUnlimited">&ensp;全部设置为“不限预算”</el-button>
            <el-button type="text" @click="onBudgetValueClearReserveConfirm" v-if="form.batchTaskType === 2">
              &ensp;全部设置为“清除定时设定”
            </el-button>
          </div>
        </el-form-item>
      </el-form>

      <el-table
        ref="table"
        class="common-el-table-styles"
        border
        :row-class-name="tableRowClassName"
        :data="tableRows"
        :height="260"
        width="100%"
      >
        <el-table-column prop="index" label="序号">
          <template slot-scope="{ $index }">
            <div>{{ $index + 1 }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="projectNameForBudget"
          v-if="modifyBudgetStates.isProject"
          label="项目/组名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="adNameForBudget" v-if="modifyBudgetStates.isAd" label="计划名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="adAccountName" v-if="modifyBudgetStates.isAccount" label="账号名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mediaName" label="媒体"></el-table-column>
        <el-table-column prop="paperUseAmount" label="当日消耗"></el-table-column>

        <el-table-column label="原预算">
          <template slot-scope="{ row }">
            <span v-if="modifyBudgetStates.isProject">{{ row.projectDayBudget === 0 ? '不限' : row.projectDayBudget }}</span>
            <span v-if="modifyBudgetStates.isAd">{{ row.budget === 0 ? '不限' : row.budget }}</span>
            <span v-if="modifyBudgetStates.isAccount">{{ row.accountDayBudget === 0 ? '不限' : row.accountDayBudget }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="form.batchTaskType === 2" label="已设定次日预算">
          <template slot-scope="{ row }">
            <span v-if="modifyBudgetStates.isProject">{{ row.bookProjectBudget === 0 ? '不限' : row.bookProjectBudget }}</span>
            <span v-if="modifyBudgetStates.isAd">{{ row.bookAdBudget === 0 ? '不限' : row.bookAdBudget }}</span>
            <span v-if="modifyBudgetStates.isAccount">{{ row.bookAccountBudget === 0 ? '不限' : row.bookAccountBudget }}</span>
          </template>
        </el-table-column>

        <el-table-column width="140">
          <template slot="header" slot-scope="scope">
            <span>修改后预算</span>
            <el-button style="margin-left: 10px" type="text" @click="removeAllBudgetValue(scope.row)">全部清除</el-button>
          </template>

          <template slot-scope="{ row }">
            <div v-if="row.hasSameProject">
              <span type="text" v-if="row.modifiedBudgetValue === -1">清除定时设定</span>
              <span type="text" v-else-if="row.modifiedBudgetValue === 0">不限</span>
              <span type="text" v-else-if="row.modifiedBudgetValue > 0">
                {{ row.modifiedBudgetValue }}
              </span>
              <span v-else>-</span>
            </div>

            <BudgetEditActionPopover
              v-else
              :value="row.modifiedBudgetValueDup"
              :radio.sync="row.budgetRadio"
              @input="onRowModifiedBudgetSave(row, $event)"
            >
              <el-button type="text" v-if="row.modifiedBudgetValue === -1">清除定时设定</el-button>
              <el-button type="text" @click="row.budgetRadio = 0" v-else-if="row.modifiedBudgetValue === 0">不限</el-button>
              <el-button type="text" @click="onRowBudgetValueClick(row)" v-else-if="row.modifiedBudgetValue > 0">
                {{ row.modifiedBudgetValue }}
              </el-button>
              <span v-else>-</span>
            </BudgetEditActionPopover>

            <!-- <el-popover v-else placement="top" trigger="click">
              <el-radio-group v-model="row.budgetRadio" class="edit-budget">
                <el-radio :label="0"> 不限 </el-radio>
                <el-radio :label="1">
                  <el-input-number
                    v-model="row.modifiedBudgetValueDup"
                    controls-position="right"
                    :disabled="row.budgetRadio === 0"
                    :precision="2"
                    :step="1"
                    :min="0"
                    :max="99999999"
                    style="width: 110px"
                  />
                </el-radio>
              </el-radio-group>

              <div style="display: inline-block">
                <el-button type="text" @click="onRowModifiedBudgetSave(row)">保存</el-button>
              </div>

              <div slot="reference" style="display: flex">
                <el-button type="text" v-if="row.modifiedBudgetValue === -1">清除定时设定</el-button>
                <el-button type="text" @click="row.budgetRadio = 0" v-else-if="row.modifiedBudgetValue === 0">不限</el-button>
                <el-button type="text" @click="onRowBudgetValueClick(row)" v-else-if="row.modifiedBudgetValue > 0">
                  {{ row.modifiedBudgetValue }}
                </el-button>
                <span v-else>-</span>
              </div>
            </el-popover> -->
          </template>
        </el-table-column>
        <el-table-column prop="index" label="操作" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span v-if="row.hasSameProject"> 与序号{{ row.hasSameProject }}的计划的项目相同，已做去重处理 </span>
            <span v-if="row.touTiaoUba && modifyBudgetStates.isAd"> UBA计划，计划预算不能修改 </span>
            <span v-if="row.mediaId === 45 && modifyBudgetStates.isAd"> 计划预算不能修改 </span>
            <el-button v-else type="text" @click="removeRow(row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <p v-show="tableValidErrorMsg" style="color: red">{{ tableValidErrorMsg }}</p>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onBatchModifyCancel">取 消</el-button>
      <el-button type="primary" :loading="confirmLoading" :disabled="rows.length === 0" @click="onBatchModifyConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import BudgetEditActionPopover from './edit-popover.vue'
import { batchBudgetModify } from '@/api/convert.model'
import { clone } from '@/common/js/just'
const getForm = () => {
  return {
    batchTaskType: 1,
    isLimited: 1,
    budgetType: 1,
    budgetValue: '',
    unitType: 1
  }
}
export default {
  components: { BudgetEditActionPopover },
  props: {
    value: Boolean,
    title: String,
    rows: {
      type: Array
    }
  },
  data() {
    return {
      confirmLoading: false,
      tableValidErrorMsg: '',
      form: getForm()
    }
  },
  computed: {
    tableRows() {
      // 当项目预算修改，标记相同项目的行
      if (this.modifyBudgetStates.isProject) {
        const obj = {}
        const projectTableRows = this.rows.map((row, index) => {
          const idx = obj[row.projectNameForBudget]
          if (typeof idx === 'number') {
            return { ...row, hasSameProject: idx }
          }
          obj[row.projectNameForBudget] = index + 1
          return row
        })
        return projectTableRows
      }

      return this.rows
    },
    dialogVisible: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    modifyBudgetStates() {
      return {
        isProject: this.title === '批量修改项目/组预算',
        isAd: this.title === '批量修改计划预算',
        isAccount: this.title === '批量修改账户预算'
      }
    }
  },
  methods: {
    onBudgetValueTypeChange(type) {
      if (type === 1) {
        this.form.unitType = 1
      }
      // 切换预算类型后计算修改后的预算值
      this.onBudgetValueConfirm()
    },
    /**
     * @description: 校验各个媒体预算值是否合法，且返回
     */
    getValidTableRows(row) {
      const { budgetRadio, modifiedBudgetValueDup, projectNameForBudget, planId, adAccountId } = row
      const { isProject, isAd, isAccount } = this.modifyBudgetStates

      // 找到对应的预算类型列的索引
      // 区分账号或项目、广告；项目和广告可以使用planId，账号只能使用adAccountId
      const index = isAccount
        ? this.rows.findIndex((item) => item.adAccountId === adAccountId)
        : this.rows.findIndex((item) => item.planId === planId)
      const item = this.rows[index]

      // 头条
      if (item.mediaId === 10) {
        if (this.modifyBudgetStates.isAd) {
          // uba 广告预算不能修改
          if (item.touTiaoUba) {
            return item
          }
          // 头条普通广告不能设置为不限
          if (!item.touTiaoUba && budgetRadio === 0) {
            throw new Error(`序号${index + 1}广告预算不能设置为不限`)
          }
        }

        if (this.modifyBudgetStates.isProject) {
          // 头条项目预算不能设置为不限，只能设置具体预算值；
          if (item.touTiaoUba && budgetRadio === 0) {
            throw new Error(`序号${index + 1}项目预算不能设置为不限`)
          }
        }
      }

      if (item.mediaId === 45) {
        if (this.modifyBudgetStates.isAd) {
          // 百度的广告预算不能修改
          return item
        }
      }

      // 腾讯广告v3不能设置项目预算
      if (!item.projectIdForBudget && this.modifyBudgetStates.isProject) {
        throw new Error(`序号${index + 1}：不能设置项目预算，请移除后重试`)
      }

      // 根据预算层级类型取对应的实时预算值
      const rawBudget = isProject ? item.projectDayBudget : isAd ? item.budget : item.accountDayBudget
      if (modifiedBudgetValueDup !== 0 && Math.abs(rawBudget - modifiedBudgetValueDup) < 100) {
        this.tableValidErrorMsg = `序号${index + 1}预算增减幅度不能小于100`
        return { ...item, modifiedBudgetValue: Math.max(modifiedBudgetValueDup, 300) }
      }

      // 项目预算修改时，如果存在多个相同项目的广告，会同时修改多个广告的项目预算
      if (this.modifyBudgetStates.isProject) {
        if (item.projectNameForBudget === projectNameForBudget) {
          // 不限为0
          if (budgetRadio === 0) {
            return { ...item, modifiedBudgetValue: 0 }
          }

          return { ...item, modifiedBudgetValue: Math.max(modifiedBudgetValueDup, 300) }
        }
      }

      if (this.modifyBudgetStates.isAd) {
        if (item.adNameForBudget === row.adNameForBudget) {
          // 不限为0
          if (budgetRadio === 0) {
            return { ...item, modifiedBudgetValue: 0 }
          }

          return { ...item, modifiedBudgetValue: Math.max(modifiedBudgetValueDup, 300) }
        }
      }

      if (this.modifyBudgetStates.isAccount) {
        if (item.adAccountName === row.adAccountName) {
          // 不限为0
          if (budgetRadio === 0) {
            return { ...item, modifiedBudgetValue: 0 }
          }

          return { ...item, modifiedBudgetValue: Math.max(modifiedBudgetValueDup, 300) }
        }
      }

      return item
    },
    /**
     * @description: 表格单个修改预算
     */
    onRowModifiedBudgetSave(row, modifiedBudgetValueDup) {
      row = { ...row, modifiedBudgetValueDup }
      try {
        const validRow = this.getValidTableRows(row)

        const { isAccount } = this.modifyBudgetStates
        if (!validRow) return

        const newRows = this.rows.map((item) => {
          // 区分账号或项目、广告；项目和广告可以使用planId，账号只能使用adAccountId
          if (isAccount && item.adAccountId === validRow.adAccountId) {
            return validRow
          } else if (!isAccount && item.planId === validRow.planId) {
            return validRow
          }
          return item
        })
        this.$emit('update:rows', newRows)
      } catch (e) {
        this.tableValidErrorMsg = e.message
      }
    },

    /**
     * @description: 批量设置
     */
    onBudgetValueConfirm() {
      const { budgetValue, unitType, budgetType } = this.form
      const budgetValueNum = Number(budgetValue)
      this.tableValidErrorMsg = ''
      if (budgetValue.trim() === '') return
      if (Object.is(budgetValueNum, NaN)) return this.$Message.warning('预算值请输入数字')

      const { isProject, isAd } = this.modifyBudgetStates

      try {
        let newRows = this.rows.map((item) => {
          let value = budgetValueNum

          // 根据预算层级类型取对应的预算值
          const rawBudget = isProject ? item.projectDayBudget : isAd ? item.budget : item.accountDayBudget

          // 处理原预算为不限的情况，不限预算任何增加预算、减少预算都不作处理
          if (rawBudget === 0 && [2, 3].includes(budgetType)) {
            return { ...item, budgetRadio: 0, modifiedBudgetValue: 0 }
          }

          // 在原有预算基础增加百分比
          if (budgetType === 2 && unitType === 2) {
            value = rawBudget + (rawBudget * budgetValueNum) / 100
          }
          // 在原有预算基础增加固定值
          if (budgetType === 2 && unitType === 1) {
            value = rawBudget + budgetValueNum
          }
          // 在原有预算基础减少百分比
          if (budgetType === 3 && unitType === 2) {
            value = rawBudget - (rawBudget * budgetValueNum) / 100
          }
          // 在原有预算基础减少固定值
          if (budgetType === 3 && unitType === 1) {
            value = rawBudget - budgetValueNum
          }

          return { ...item, budgetRadio: 1, modifiedBudgetValueDup: value }
        })

        newRows = newRows.map((item) => this.getValidTableRows(item))

        this.$emit('update:rows', newRows)
      } catch (e) {
        this.tableValidErrorMsg = e.message
      }
    },
    /**
     * @description: 设置预算为不限
     */
    onBudgetValueUseUnlimited() {
      try {
        const newRows = this.rows.map((item) => {
          return this.getValidTableRows({ ...item, budgetRadio: 0, modifiedBudgetValueDup: 0 })
        })

        this.$emit('update:rows', newRows)
      } catch (e) {
        this.tableValidErrorMsg = e.message
      }
    },
    /**
     * @description: 表格全部设置为清除定时任务
     * @return {*}
     */
    onBudgetValueClearReserveConfirm() {
      const newRows = this.rows.map((item) => {
        return { ...item, modifiedBudgetValue: -1 }
      })
      this.$emit('update:rows', newRows)
    },

    buildParams() {
      const { batchTaskType } = this.form
      const taskList = this.tableRows
        // 过滤掉同项目的计划
        .filter((item) => !item.hasSameProject)
        // 头条uba广告预算不能修改，忽略
        .filter((item) => {
          if (this.modifyBudgetStates.isAd) {
            if (item.touTiaoUba) return false
          }
          return true
        })
        // 百度的广告预算不能修改，忽略
        .filter((item) => {
          if (this.modifyBudgetStates.isAd) {
            if (item.mediaId === 45) return false
          }
          return true
        })
        .map((item) => {
          const task = {
            media_id: item.mediaId,
            biz_name: item.planName,
            plan_id: item.planId
          }

          // 预约修改： 1开启预约 0关闭预约
          // 当modifiedBudgetValue 大于等于0，开启预约修改
          // 当modifiedBudgetValue 等于-1，取消预约
          if (batchTaskType === 2) {
            task.enable_book = item.modifiedBudgetValue >= 0 ? 1 : 0

            // 只有开启了预约修改，才需要设置预约的预算
            if (task.enable_book) {
              task.target_budget = item.modifiedBudgetValue
            }
          } else {
            // 直接修改
            task.target_budget = item.modifiedBudgetValue
          }

          if (this.modifyBudgetStates.isProject) {
            task.biz_type = 2
            task.biz_id = item.projectIdForBudget
            task.old_budget = item.projectDayBudget
          }

          if (this.modifyBudgetStates.isAd) {
            task.biz_type = 3
            task.biz_id = item.adIdForBudget
            task.old_budget = item.budget
          }

          if (this.modifyBudgetStates.isAccount) {
            task.biz_type = 1
            task.biz_id = item.advertiserId
            task.biz_name = item.adAccountName
            task.old_budget = item.accountDayBudget
            task.ad_account_id = item.adAccountId
          }

          if (typeof task.target_budget !== 'number') {
            throw new Error(`${task.biz_name}：预算不能为空`)
          }

          return task
        })

      return {
        batch_task_type: batchTaskType,
        task_list: taskList
      }
    },
    /**
     * @description: 批量修改预算提交
     */
    onBatchModifyConfirm() {
      const { batchTaskType } = this.form
      this.tableValidErrorMsg = ''

      try {
        // 提交前先校验一次，构造modifiedBudgetValueDup、budgetRadio 用于校验
        this.rows.forEach((row) =>
          this.getValidTableRows({
            ...row,
            modifiedBudgetValueDup: row.modifiedBudgetValue,
            budgetRadio: row.modifiedBudgetValue > 0
          })
        )

        const params = this.buildParams()

        if (this.tableValidErrorMsg) return
        this.tableValidErrorMsg = ''
        this.confirmLoading = true
        batchBudgetModify(params)
          .then((data) => {
            this.onBatchModifyCancel()
            this.$emit('refresh')
            if (batchTaskType === 2) {
              if (data) {
                this.$Message.success('批量预约修改成功')
              }
            }

            if (batchTaskType === 1) {
              if (data?.length) {
                this.$emit('results', data)
              }
            }
          })
          .finally(() => {
            this.confirmLoading = false
          })
      } catch (e) {
        console.log('eeee output: ', e)
        this.tableValidErrorMsg = e.message
      }
    },
    onRowBudgetValueClick(row) {
      row.budgetRadio = 1
      row.modifiedBudgetValueDup = row.modifiedBudgetValue
    },
    onBatchModifyCancel() {
      this.dialogVisible = false
      this.confirmLoading = false
      this.tableValidErrorMsg = ''
      this.form = getForm()
    },
    /**
     * @description: 切换生效方式时，清空修改后的预算列
     */
    onBatchTaskTypeChange() {
      this.removeAllBudgetValue()
    },
    /**
     * @description: 清除全部预算设置
     */
    removeAllBudgetValue(row) {
      const newRows = this.rows.map((item) => ({ ...item, modifiedBudgetValue: null }))
      this.$emit('update:rows', newRows)
      this.form.budgetValue = ''
    },
    /**
     * @description: 移除已选行
     * @param {*} row
     */
    removeRow(row) {
      const newRows = this.rows.filter((item) => item.planName !== row.planName)
      this.$emit('update:rows', newRows)

      this.tableValidErrorMsg = ''
    },
    tableRowClassName({ row }) {
      if (row.hasSameProject) return 'row-disabled'
      if (row.touTiaoUba && this.modifyBudgetStates.isAd) return 'row-disabled'
      if (row.mediaId === 45 && this.modifyBudgetStates.isAd) return 'row-disabled'
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-title {
  display: flex;
  align-items: center;
  h4 {
    font-size: 18px;
  }
  span {
    margin-left: 20px;
  }
}
.budget-value {
  display: flex;

  .budget-input {
    margin-left: 5px;
    ::v-deep .el-input-group__append {
      width: 70px;
    }
  }
}

::v-deep .el-table {
  .row-disabled {
    color: #a4a4a4;
    cursor: not-allowed;
  }
}
</style>
